<script>
import axios from 'axios'
import * as XLSX from 'xlsx'
import moment from 'moment'
import { mask } from 'vue-the-mask'

export default {
  directives: { mask },
  components: {},

  data: (vm) => ({
    arrayBuffer: [],
    errorFlagMsg: null,
    detailsModal: false,
    selectedSearchedUser: null,
    searchResult: [],
    searchHeader: [
      { text: 'First Name', value: 'first_name' },
      { text: 'Last Name', value: 'last_name' },
      { text: 'Date of Birth', value: 'dob' },
      { text: 'Gender', value: 'gender' },
      { text: 'Email', value: 'email' },
      { text: 'Status', value: 'status' },
      { text: 'Action', value: 'loading' },
      { text: 'Is Admin', value: 'isAdmin' },
    ],

    searchHeaderProvider: [
      { text: 'First Name', value: 'first_name' },
      { text: 'Last Name', value: 'last_name' },
      { text: 'Date of Birth', value: 'dob' },
      { text: 'Gender', value: 'gender' },
      { text: 'Email', value: 'email' },
      { text: 'Status', value: 'status' },
      { text: 'Action', value: 'loading' },
      { text: 'Is Admin', value: 'isAdmin' },
    ],
    searchError: '',
    activeTab: 'tab1',
    errorFlag: false,
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    isAdmin: false,
    environmentSelected: null,
    environmentSelectedSearch: null,
    selectedOrgSearch: null,
    states: '',
    credentials: '',
    isActiveTelehealth: true,
    isActivePeer: true,
    menu: false,
    isProvider: false,
    modal: false,
    menu2: false,
    errorMessage: null,
    speciality: [
      {
        speciality_id: 1,
        speciality_name: 'Peer Coach',
      },
      {
        speciality_id: 2,
        speciality_name: 'Counselor',
      },
    ],
    dialogReset: false,
    successMessage: '',
    invalidFile: true,
    invalidFileMessage: '',
    confirmPopup: 'note',
    tabSelectedMain: 'user',
    selectedOrg: null,
    hbpSecretKey: null,
    isVisible: false,
    tabs: [
      { index: 1, name: 'Valid Records' },
      { index: 0, name: 'Invalid Records' },
      { index: 2, name: 'Response' },
    ],
    importResponce: undefined,
    breadCrumbs: [
      {
        text: 'Home',
        disabled: false,
        href: 'breadcrumbs_dashboard',
      },
      {
        text: 'Organization',
        disabled: true,
        href: 'breadcrumbs_link_1',
      },
    ],
    importMultiple: null,
    tabSelected: 0,
    dialogSmall: false,
    dialogSmallLogo: false,
    headers: [
      {
        text: 'Short Name',
        align: 'start',
        sortable: false,
        value: 'short_name',
      },
      { text: 'Full Name', value: 'full_name' },
      { text: 'Country', value: 'country' },
      { text: 'Contact', value: 'contact' },
      { text: 'Logo', value: 'logo' },
    ],
    responseHeaderSaved: [
      { text: 'Saved Email', value: 'EMAIL', class: 'saved--text' },
    ],
    responseHeaderexistingemails: [
      { text: 'Existing Email', value: 'EMAIL', class: 'existing--text' },
    ],
    responseHeaderexistinguseremail: [
      { text: 'Existing User Email', value: 'EMAIL', class: 'existing--text' },
    ],

    userHeader: [
      { text: 'First Name', value: 'First_Name' },
      { text: 'Last Name', value: 'Last_Name' },
      { text: 'Date of Birth', value: 'DOB' },
      { text: 'Gender', value: 'GENDER' },
      { text: 'Email', value: 'EMAIL' },
    ],
    userHeaderProvider: [
      { text: 'First Name', value: 'First_Name' },
      { text: 'Last Name', value: 'Last_Name' },
      { text: 'Date of Birth', value: 'DOB' },
      { text: 'Gender', value: 'GENDER' },
      { text: 'Email', value: 'EMAIL' },

      { text: 'Credentials', value: 'credential' },
      { text: 'Npi Number', value: 'npi_number' },
      { text: 'Speciality', value: 'speciality' },

      { text: 'Address', value: 'address_line_1' },
      { text: 'City', value: 'city' },
      { text: 'Zip Code', value: 'zip_code' },
      { text: 'State', value: 'state' },
      { text: 'Phone Number', value: 'phone_number' },
      { text: 'Doxy Me Link', value: 'doxy_me_link' },
      { text: 'Is Active Peer Coaching', value: 'is_active_peer_coaching' },
      {
        text: 'Is Active Telehealth Consultation',
        value: 'is_active_telehealth_consultation',
      },
      { text: 'Is Active', value: 'is_admin' },
    ],
    records: [],
    validRecors: [],
    invalidRecords: [],

    desserts: [],

    valid: false,
    phoneRule: [
      (v) =>
        !v.length > 0 ||
        /^(\+1)?\s?[0-9]{3}?[-\s.][0-9]{3}[-\s.]?[0-9]{4,6}$/.test(v) ||
        'The phone number entered is not valid (+1 ###-###-####).',
    ],

    doxyRule: [
      (v) => !!v || 'Field is required',
      (v) =>
        !v.length > 0 ||
        /^https:\/\/doxy\.me\/[^\s(["<,>]*/.test(v) ||
        'Doxy link must start fron https://doxy.me/***',
    ],

    nameRules: [(v) => !!v || 'Field is required'],
    npiRule: [
      (v) => !!v || 'Field is required',
      (v) =>
        !v ||
        !v.length > 0 ||
        /^\d{10}$/.test(v) ||
        'Invalid NPI Code,It should be 10 digit number.',
    ],

    zipRule: [
      (v) =>
        !v ||
        !v.length > 0 ||
        /^\d{5}(-\d{4})?$/.test(v) ||
        'Invalid Zip Code,It should be in the format of 12345 or 12345-1234.',
    ],
    dobRule: [
      (v) =>
        !v ||
        !v.length > 0 ||
        /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/.test(v) ||
        'Invalid Date',
    ],
    logoRules: [(v) => !!v || 'Field is required'],
    email: '',
    emailRules: [
      (v) => !!v || 'Contact is required',
      (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],

    emailRulesNotReq: [
      (v) => !v.length > 0 || /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    select: null,
    items: [],
    providerItems: [
      {
        id: 2,
        short_name: 'healthbook',
        full_name: 'Healthbook',
        country: 'USA',
        logo: '',
        contact: 'lykourgos.tzardis@healthbookplus.com',
        insertts: '2021-12-30T09:53:03.442400Z',
        updatets: '2021-12-30T09:53:03.442427Z',
      },
    ],
    organization: {
      name: '',
      shortname: '',
      country: '',
      contact: '',
    },

    userDetails: {
      firstName: null,
      lastName: null,
      dob: '',
      dateFormatted: vm.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      ),
      gender: '',
      email: '',
      hbp_secret_key: '',
      credential: '',
      npi_number: '',
      speciality: '',
      address_line_1: '',
      city: '',
      zip_code: '',
      state: '',
      phone_number: '',
      doxy_me_link: '',
      is_active_peer_coaching: true,
      biography: '',
      is_active_telehealth_consultation: true,
      is_admin: false,
    },

    searchDetails: {
      first_name: '',
      last_name: '',
      dob: '',
      gender: '',
      email: '',
    },

    userDetailsArray: [
      {
        firstName: null,
        lastName: null,
        dob: '',
        dateFormatted: vm.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
        ),
        gender: null,
        email: null,
        hbp_secret_key: '',
        credential: '',
        npi_number: '',
        speciality: '',
        address_line_1: '',
        city: '',
        zip_code: '',
        state: '',
        phone_number: '',
        doxy_me_link: '',
        is_active_peer_coaching: true,
        biography: '',
        is_active_telehealth_consultation: true,
        is_admin: false,
      },
    ],
    providerDetailsArray: [
      {
        firstName: '',
        lastName: '',
        dob: '',
        dateFormatted: vm.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10)
        ),
        gender: '',
        email: '',
        hbp_secret_key: '',
        credential: '',
        npi_number: '',
        speciality: '',
        address_line_1: '',
        city: '',
        zip_code: '',
        state: '',
        phone_number: '',
        doxy_me_link: '',
        is_active_peer_coaching: true,
        biography: '',
        is_active_telehealth_consultation: true,
        is_admin: false,
      },
    ],

    orgDetails: {},
    genderDD: [
      { key: 'M', name: 'Male' },
      { key: 'F', name: 'Female' },
      { key: 'O', name: 'Other' },
      { key: 'TM', name: 'Transgender-Male' },
      { key: 'TF', name: 'Transgender-Female' },
      { key: 'NB', name: 'Non-Binary' },
      { key: 'ND', name: 'Non-Disclose' },
    ],
    selectedItem: null,
    menuActionType: '',
    reasonText: '',
  }),

  computed: {
    getSearchFormError() {
      if (this.errorFlag) {
        if (
          this.searchDetails.first_name.trim() === '' &&
          this.searchDetails.last_name.trim() === '' &&
          this.searchDetails.dob.trim() === '' &&
          this.searchDetails.gender.trim() === '' &&
          this.searchDetails.email.trim() === ''
        ) {
          return '*Please fill atleast one field'
        } else return null
      } else return null
    },
    computedDateFormatted(date) {
      if (date !== '') {
        return this.formatDate(date)
      } else return null
    },
    submitButton() {
      return (
        this.valid &&
        this.environmentSelected &&
        this.selectedOrg &&
        this.hbpSecretKey
      )
    },

    submitButtonimport() {
      return (
        !this.invalidFile &&
        this.environmentSelected &&
        this.selectedOrg &&
        this.hbpSecretKey
      )
    },
    openReasonDialog() {
      if (this.resultActionType !== '' && this.selectedItem) return true
      else return false
    },
  },

  watch: {
    date(val) {
      if (this.userDetails.dob !== '') {
        this.dateFormatted = this.formatDate(this.userDetails.dob)
      }
    },
    getButtonDisable() {
      return this.invalidFile ? 'disabledButton' : ''
    },
  },

  async mounted() {
    const optionData = {
      marital_status: [
        { key: 'Single (never married)', value: 'Single (never married)' },
        {
          key: 'Married/ Domestic Partnership',
          value: 'Married/ Domestic Partnership',
        },
        { key: 'Widowed', value: 'Widowed' },
        { key: 'Divorced', value: 'Divorced' },
        { key: 'Separated', value: 'Separated' },
      ],
      race: [
        {
          key: 'American Indian / Alaskan Native',
          value: 'American Indian / Alaskan Native',
        },
        { key: 'Asian / Pacific Islander', value: 'Asian / Pacific Islander' },
        { key: 'Black / African American', value: 'Black / African American' },
        { key: 'Hispanic', value: 'Hispanic' },
        { key: 'White / Caucasian', value: 'White / Caucasian' },
        { key: 'Other', value: 'Other' },
        { key: 'Unknown', value: 'Unknown' },
      ],
      gender: [
        { key: 'M', value: 'Male' },
        { key: 'F', value: 'Female' },
        { key: 'TM', value: 'Transgender male' },
        { key: 'TF', value: 'Transgender female' },
        { key: 'GNB', value: 'Gender non-binary' },
        { key: 'GNC', value: 'Gender non-confirming' },
        { key: 'RND', value: 'Rather not dicslose' },
      ],
      sex: [
        { key: 'M', value: 'Male' },
        { key: 'F', value: 'Female' },
        { key: 'I', value: 'Intersex' },
        { key: 'RND', value: 'Rather not disclose' },
      ],
      relationship: [
        { key: 'Spouse', value: 'Spouse' },
        { key: 'Domestic Partner', value: 'Domestic Partner' },
        { key: 'Child', value: 'Child' },
        { key: 'Parent', value: 'Parent' },
        { key: 'Sibling', value: 'Sibling' },
        { key: 'Grandparent', value: 'Grandparent' },
        { key: 'Aunt / Uncle', value: 'Aunt / Uncle' },
        { key: 'Niece / Nephew', value: 'Niece / Nephew' },
        { key: 'Caretaker', value: 'Caretaker' },
        { key: 'Other', value: 'Other' },
        { key: 'Spouse', value: 'Spouse' },
        { key: 'Domestic Partner', value: 'Domestic Partner' },
        { key: 'Child', value: 'Child' },
        { key: 'Parent', value: 'Parent' },
        { key: 'Sibling', value: 'Sibling' },
        { key: 'Grandparent', value: 'Grandparent' },
        { key: 'Aunt / Uncle', value: 'Aunt / Uncle' },
        { key: 'Niece / Nephew', value: 'Niece / Nephew' },
        { key: 'Caretaker', value: 'Caretaker' },
        { key: 'Other', value: 'Other' },
      ],
      credentials: [
        {
          credential_id: 13,
          credential_name: 'CNNP',
          credential_description: 'Certified Neonatal Nurse Practitioner',
          organization_id: 4,
        },
        {
          credential_id: 14,
          credential_name: 'CNM',
          credential_description: 'Certified Nurse Midwife',
          organization_id: 4,
        },
        {
          credential_id: 15,
          credential_name: 'CNP',
          credential_description: 'Certified Nurse Practitioner',
          organization_id: 4,
        },
        {
          credential_id: 16,
          credential_name: 'CNS',
          credential_description: 'Clinical Nurse Specialist',
          organization_id: 4,
        },
        {
          credential_id: 17,
          credential_name: 'DNP',
          credential_description: 'Doctor of Nursing Practice',
          organization_id: 4,
        },
        {
          credential_id: 18,
          credential_name: 'DO',
          credential_description: 'Doctor of Osteopathic Medicine',
          organization_id: 4,
        },
        {
          credential_id: 19,
          credential_name: 'MBBS',
          credential_description: 'Bachelor of Medicine',
          organization_id: 4,
        },
        {
          credential_id: 20,
          credential_name: 'MD',
          credential_description: 'Doctor of Medicine',
          organization_id: 4,
        },
        {
          credential_id: 21,
          credential_name: 'NP',
          credential_description: 'Nurse Practitioner',
          organization_id: 4,
        },
        {
          credential_id: 22,
          credential_name: 'PA',
          credential_description: 'Physician Assistant',
          organization_id: 4,
        },
        {
          credential_id: 23,
          credential_name: 'PHARM',
          credential_description: 'Pharmacist',
          organization_id: 4,
        },
        {
          credential_id: 24,
          credential_name: 'OTHER',
          credential_description: 'OTHER',
          organization_id: 4,
        },
      ],
      states: [
        { key: 'AK', value: 'Alaska' },
        { key: 'AL', value: 'Alabama' },
        { key: 'AZ', value: 'Arizona' },
        { key: 'AR', value: 'Arkansas' },
        { key: 'CA', value: 'California' },
        { key: 'CO', value: 'Colorado' },
        { key: 'CT', value: 'Connecticut' },
        { key: 'DE', value: 'Delaware' },
        { key: 'DC', value: 'District of Columbia' },
        { key: 'FL', value: 'Florida' },
        { key: 'GA', value: 'Georgia' },
        { key: 'HI', value: 'Hawaii' },
        { key: 'ID', value: 'Idaho' },
        { key: 'IL', value: 'Illinois' },
        { key: 'IN', value: 'Indiana' },
        { key: 'IA', value: 'Iowa' },
        { key: 'KS', value: 'Kansas' },
        { key: 'KY', value: 'Kentucky' },
        { key: 'LA', value: 'Louisiana' },
        { key: 'ME', value: 'Maine' },
        { key: 'MD', value: 'Maryland' },
        { key: 'MA', value: 'Massachusetts' },
        { key: 'MI', value: 'Michigan' },
        { key: 'MN', value: 'Minnesota' },
        { key: 'MS', value: 'Mississippi' },
        { key: 'MO', value: 'Missouri' },
        { key: 'MT', value: 'Montana' },
        { key: 'NE', value: 'Nebraska' },
        { key: 'NV', value: 'Nevada' },
        { key: 'NH', value: 'New Hampshire' },
        { key: 'NJ', value: 'New Jersey' },
        { key: 'NM', value: 'New Mexico' },
        { key: 'NY', value: 'New York' },
        { key: 'NC', value: 'North Carolina' },
        { key: 'ND', value: 'North Dakota' },
        { key: 'OH', value: 'Ohio' },
        { key: 'OK', value: 'Oklahoma' },
        { key: 'OR', value: 'Oregon' },
        { key: 'PA', value: 'Pennsylvania' },
        { key: 'PR', value: 'Puerto Rico' },
        { key: 'RI', value: 'Rhode Island' },
        { key: 'SC', value: 'South Carolina' },
        { key: 'SD', value: 'South Dakota' },
        { key: 'TN', value: 'Tennessee' },
        { key: 'TX', value: 'Texas' },
        { key: 'UT', value: 'Utah' },
        { key: 'VT', value: 'Vermont' },
        { key: 'VA', value: 'Virginia' },
        { key: 'WA', value: 'Washington' },
        { key: 'WV', value: 'West Virginia' },
        { key: 'WI', value: 'Wisconsin' },
        { key: 'WY', value: 'Wyoming' },
      ],
    }

    this.states = optionData.states
    this.credentials = [
      {
        credential_id: 1,
        credential_name: 'CAPRC',
        description: 'Certified Addiction Peer Recovery Coach',
      },
      {
        credential_id: 2,
        credential_name: 'CPRS',
        description: 'Certified Peer Recovery Specialist',
      },
      {
        credential_id: 3,
        credential_name: 'DMin',
        description: 'Doctor of Ministry',
      },
      {
        credential_id: 4,
        credential_name: 'LCMHC',
        description: 'Licensed Clinical Mental Health Counselor',
      },
      {
        credential_id: 5,
        credential_name: 'LCPC',
        description: 'Licensed Clinical Professional Counselor',
      },
      {
        credential_id: 6,
        credential_name: 'LMHC',
        description: 'Licensed Mental Health Counselor',
      },
      {
        credential_id: 7,
        credential_name: 'LCMHP',
        description: 'Licensed Certified Mental Health Professional',
      },
      {
        credential_id: 8,
        credential_name: 'LPC',
        description: 'Licensed Professional Counselor',
      },
      {
        credential_id: 9,
        credential_name: 'LPCC',
        description:
          'Licensed Professional Clinical Counselors of Mental Health',
      },
      {
        credential_id: 10,
        credential_name: 'MD',
        description: 'Doctor of Medicine',
      },
      {
        credential_id: 11,
        credential_name: 'MFCC',
        description: 'Marriage , Family and Child Counselor',
      },
      {
        credential_id: 12,
        credential_name: 'PhD',
        description: 'Doctor of Philosophy',
      },
      {
        credential_id: 13,
        credential_name: 'PsyD',
        description: 'Doctor of Psychology',
      },
      {
        credential_id: 14,
        credential_name: 'NP/RN',
        description: ' Nurse Practitioner/ Registered Nurse',
      },
    ]
  },

  created: function () {
    this.tabSelectedMain = 'Patients'
    this.getData()
  },

  methods: {
    changeAdmin(ev, item) {
      let url = ''

      if (this.isProvider) {
        if (this.environmentSelectedSearch !== 'prod')
          url = `https://provider-portal-${this.environmentSelectedSearch}.myhealthbookplus.com/api/v1/importprovider/search_provider/`
        else
          url = `https://provider-portal.myhealthbookplus.com/api/v1/importprovider/search_provider/`

        const obj = {
          hbp_secret_key: this.hbpSecretKey,
          admin_status: ev,
          provider_id: item.provider_id,
        }

        axios
          .put(url, obj)
          .then((res) => {})
          .catch((err) => {
            console.warn(err.response.data)
          })
      }
    },
    changeTabs() {
      this.errorFlag = null
      this.searchResult = []
    },
    resultMenuAction(actionType, item) {
      this.menuActionType = actionType
      this.selectedItem = item
    },
    handleConfirmReason() {
      switch (this.menuActionType) {
        case 'resend-confirm-email':
          this.resendEmail(this.selectedItem)
      }
      this.menuActionType = ''
      this.selectedItem = null
      this.reasonText = ''
    },
    handleCancelReason() {
      this.menuActionType = ''
      this.selectedItem = null
      this.reasonText = ''
    },
    resendEmail(item) {
      if (
        !(
          item.loading ||
          item.sendSuccess ||
          item.sendError ||
          item.has_email_confirmed
        )
      ) {
        let url
        item.loading = true
        if (this.isProvider) {
          if (this.environmentSelectedSearch !== 'prod')
            url = `https://provider-portal-${this.environmentSelectedSearch}.myhealthbookplus.com/api/v1/importprovider/resend_access_code/`
          else
            url = `https://provider-portal.myhealthbookplus.com/api/v1/importprovider/resend_access_code/`
        } else {
          if (this.environmentSelectedSearch !== 'prod')
            url = `https://${this.environmentSelectedSearch}.myhealthbookplus.com/api/v1/csvusers/resend_access_code/`
          else
            url = `https://myhealthbookplus.com/api/v1/csvusers/resend_access_code/`
        }
        const obj = {
          org_id: this.selectedOrgSearch,
          email: item.email,
          access_code: item.access_code,
          user_id: item.user_id ? item.user_id : undefined,
          provider_id: item.provider_id ? item.provider_id : undefined,
        }
        axios
          .post(url, obj)
          .then((res) => {
            item.sendSuccess = true
            item.loading = false
          })
          .catch((err) => {
            console.warn(err.response.data)
            item.sendSuccess = false
            item.sendError = true
            item.loading = false
          })
      }
    },
    searchUser() {
      this.errorFlagMsg = null
      this.searchResult = []
      this.errorFlag = true
      if (
        this.searchDetails.first_name.trim() === '' &&
        this.searchDetails.last_name.trim() === '' &&
        this.searchDetails.dob.trim() === '' &&
        this.searchDetails.gender.trim() === '' &&
        this.searchDetails.email.trim() === ''
      ) {
        this.searchError = '*Please fill at least one field'
      } else if (
        this.$refs.form.validate() &&
        this.environmentSelectedSearch &&
        this.selectedOrgSearch &&
        this.hbpSecretKey
      ) {
        this.startLoader()
        var url
        if (this.isProvider) {
          if (this.environmentSelectedSearch !== 'prod')
            url = `https://provider-portal-${this.environmentSelectedSearch}.myhealthbookplus.com/api/v1/importprovider/search_provider/`
          else
            url = `https://provider-portal.myhealthbookplus.com/api/v1/importprovider/search_provider/`
        } else {
          if (this.environmentSelectedSearch !== 'prod')
            url = `https://${this.environmentSelectedSearch}.myhealthbookplus.com/api/v1/csvusers/search_users/`
          else
            url = `https://myhealthbookplus.com/api/v1/csvusers/search_users/`
        }

        const obj = {
          hbp_secret_key: this.hbpSecretKey,
          first_name: this.searchDetails.first_name,
          last_name: this.searchDetails.last_name,
          dob: this.searchDetails.dob
            ? moment(this.searchDetails.dob).format('YYYY-MM-DD')
            : '',
          email: this.searchDetails.email,
          gender: this.searchDetails.gender,
          organization_id: this.selectedOrgSearch,
        }
        axios
          .post(url, obj)
          .then((res) => {
            if (res.status === 200) {
              res.data.map((rec) => {
                rec.sendSuccess = false
                rec.sendError = false
                rec.loading = false
              })
              this.searchError = ''
              this.searchResult = res.data
              this.stopLoader()
            } else {
              this.stopLoader()
            }
          })
          .catch((err) => {
            this.stopLoader()
            console.warn(err.response.data)

            this.errorFlagMsg = err.response.data
          })
      }
    },
    openDetailsModal(item) {
      this.selectedSearchedUser = item
      this.detailsModal = true
    },
    changeEnv() {
      this.selectedOrg = null
      if (
        this.isProvider &&
        (this.environmentSelected === 'stage' ||
          this.environmentSelected === 'prod')
      ) {
        this.providerItems = [
          {
            id: 2,
            short_name: 'healthbook',
            full_name: 'Healthbook',
            country: 'USA',
            logo: '',
            contact: 'lykourgos.tzardis@healthbookplus.com',
            insertts: '2021-12-30T09:53:03.442400Z',
            updatets: '2021-12-30T09:53:03.442427Z',
          },
        ]
      } else {
        this.providerItems = [
          {
            id: 2,
            short_name: 'healthbook',
            full_name: 'Healthbook+',
            country: 'USA',
            logo: '',
            contact: 'lykourgos.tzardis@healthbookplus.com',
            insertts: '2021-12-30T09:53:03.442400Z',
            updatets: '2021-12-30T09:53:03.442427Z',
          },
        ]
      }
    },

    changeEnvPatient() {
      if (!this.isProvider && this.environmentSelected === 'dev') {
        this.items = [
          {
            id: 3,
            short_name: 'healthbook',
            full_name: 'HealthBook+',
            country: 'USA',
            logo: '',
            contact: 'lykourgos.tzardis@healthbookplus.com',
            insertts: '2021-12-30T09:53:03.442400Z',
            updatets: '2021-12-30T09:53:03.442427Z',
          },
        ]
      } else {
        this.items = [
          {
            id: 3,
            short_name: 'healthbook',
            full_name: 'HealthBook+',
            country: 'USA',
            logo: '',
            contact: 'lykourgos.tzardis@healthbookplus.com',
            insertts: '2021-12-30T09:53:03.442400Z',
            updatets: '2021-12-30T09:53:03.442427Z',
          },
        ]
      }
    },

    changeEnvSearch() {
      this.selectedOrgSearch = []
      if (this.isProvider) {
        this.selectedOrg = null
        if (
          this.isProvider &&
          (this.environmentSelectedSearch === 'stage' ||
            this.environmentSelectedSearch === 'prod')
        ) {
          this.providerItems = [
            {
              id: 2,
              short_name: 'healthbook',
              full_name: 'Healthbook',
              country: 'USA',
              logo: '',
              contact: 'lykourgos.tzardis@healthbookplus.com',
              insertts: '2021-12-30T09:53:03.442400Z',
              updatets: '2021-12-30T09:53:03.442427Z',
            },
          ]
        } else {
          this.providerItems = [
            {
              id: 2,
              short_name: 'healthbook',
              full_name: 'Healthbook+',
              country: 'USA',
              logo: '',
              contact: 'lykourgos.tzardis@healthbookplus.com',
              insertts: '2021-12-30T09:53:03.442400Z',
              updatets: '2021-12-30T09:53:03.442427Z',
            },
          ]
        }
      } else {
        if (!this.isProvider && this.environmentSelectedSearch === 'dev') {
          this.items = [
            {
              id: 3,
              short_name: 'healthbook',
              full_name: 'HealthBook+',
              country: 'USA',
              logo: '',
              contact: 'lykourgos.tzardis@healthbookplus.com',
              insertts: '2021-12-30T09:53:03.442400Z',
              updatets: '2021-12-30T09:53:03.442427Z',
            },
          ]
        } else {
          this.items = [
            {
              id: 3,
              short_name: 'healthbook',
              full_name: 'HealthBook+',
              country: 'USA',
              logo: '',
              contact: 'lykourgos.tzardis@healthbookplus.com',
              insertts: '2021-12-30T09:53:03.442400Z',
              updatets: '2021-12-30T09:53:03.442427Z',
            },
          ]
        }
      }
    },
    acceptNumber() {
      var x = this.userDetails.phone_number
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      this.userDetails.phone_number = !x[2]
        ? x[1]
        : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '')
    },
    isLetter(e) {
      const char = String.fromCharCode(e.keyCode) // Get the character
      if (/^[A-Za-z, ]+$/.test(char)) return true
      // Match with regex
      else e.preventDefault() // If not match, don't add to input text
    },
    isNotLetter(e) {
      const char = String.fromCharCode(e.keyCode) // Get the character
      if (!/^[A-Za-z]+$/.test(char)) return true
      // Match with regex
      else e.preventDefault() // If not match, don't add to input text
    },
    addUser() {
      this.invalidFileMessage = null
      this.hbpSecretKey = null
    },
    resetPatientForm() {
      this.userDetailsArray = []
      this.environmentSelected = null
      this.selectedOrg = null
      this.hbpSecretKey = ''
      this.$refs.form.reset()
      this.addPatient()
      this.dialogReset = false
    },

    resetFormProvider() {
      this.providerDetailsArray = []
      this.environmentSelected = null
      this.selectedOrg = null
      this.hbpSecretKey = ''
      this.$refs.form.reset()
      this.addProvider()
      this.dialogReset = false
    },
    cancelRow(ev) {
      if (this.userDetailsArray.length !== 1)
        this.userDetailsArray.splice(ev, 1)
      else {
        this.userDetailsArray.splice(ev, 1)
        this.addPatient()
      }
    },

    cancelRowProvider(ev) {
      if (this.providerDetailsArray.length !== 1)
        this.providerDetailsArray.splice(ev, 1)
      else {
        this.providerDetailsArray.splice(ev, 1)
        this.addProvider()
      }
    },

    addPatient() {
      this.userDetailsArray.push({
        firstName: null,
        lastName: null,
        dob: '',
        dateFormatted: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
        gender: '',
        email: null,
        hbp_secret_key: '',
        credential: '',
        npi_number: '',
        speciality: '',
        address_line_1: '',
        city: '',
        zip_code: '',
        state: '',
        phone_number: null,
        doxy_me_link: '',
        is_active_peer_coaching: true,
        biography: '',
        is_active_telehealth_consultation: true,
        is_admin: false,
      })
    },

    addProvider() {
      this.providerDetailsArray.push({
        firstName: '',
        lastName: '',
        dob: '',
        dateFormatted: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
        gender: '',
        email: '',
        hbp_secret_key: '',
        credential: '',
        npi_number: '',
        speciality: '',
        address_line_1: '',
        city: '',
        zip_code: '',
        state: '',
        phone_number: '',
        doxy_me_link: '',
        is_active_peer_coaching: true,
        biography: '',
        is_active_telehealth_consultation: true,
        is_admin: false,
      })
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}-${day}-${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },

    logoutUpdated() {
      this.startLoader()
    },
    startLoader() {
      this.isVisible = true
    },
    stopLoader() {
      this.isVisible = false
    },
    uploadFile(e) {
      this.invalidFile = false
      this.invalidFileMessage = ''
      if (e !== null) {
        this.Images = e

        this.submitFile()
      } else {
        this.importResponce = undefined
        this.validRecors = []
        this.invalidRecords = []
        this.tabSelected = 0
      }
    },
    submitFile() {
      var array = this.Images.name.split('.')
      this.records = []
      this.invalidRecords = []
      this.validRecors = []
      if (
        array[array.length - 1] === 'xls' ||
        array[array.length - 1] === 'csv' ||
        array[array.length - 1] === 'xlsx'
      ) {
        var fileReader = new FileReader()
        fileReader.readAsArrayBuffer(this.Images)
        fileReader.onload = (e) => {
          this.arrayBuffer = fileReader.result
          var data = new Uint8Array(this.arrayBuffer)
          var arr = []
          for (var i = 0; i !== data.length; ++i)
            arr[i] = String.fromCharCode(data[i])
          var bstr = arr.join('')

          var workbook = XLSX.read(bstr, { type: 'binary' })
          var firstSheetName = workbook.SheetNames[0]
          var worksheet = workbook.Sheets[firstSheetName]
          if (JSON.stringify(worksheet).includes('First_Name')) {
            var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: false })

            this.records = arraylist
            this.getValidateData(this.records)
          } else {
            this.invalidFile = true
            this.invalidFileMessage = '* Invalid File format'
          }
        }
      } else {
        this.invalidFile = true
        this.invalidFileMessage = '* Invalid File format'
      }
    },
    getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow) {
      const csvArr = []
      for (let i = 1; i < csvRecordsArray.length; i++) {
        const curruntRecord = csvRecordsArray[i].split(',')
        if (curruntRecord.length === headersRow.length) {
          var obj = {}
          for (let j = 0; j < headersRow.length; j++) {
            if (headersRow[j] === 'DOB') obj[headersRow[j]] = curruntRecord[j]
            else obj[headersRow[j]] = curruntRecord[j].trim()
          }
          csvArr.push(obj)
        }
      }
      return csvArr
    },

    consvertDate(date) {
      var dateParts = date.split('-')

      return dateParts[0] + '-' + dateParts[1] + '-' + dateParts[2]
    },
    validateEmail(value) {
      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        return true
      } else {
        return false
      }
    },

    getDubliacteRecords(data) {
      const id = data
      const count = this.validRecors.filter((obj) => obj.EMAIL === id).length

      if (count === 0) return true
      else return false
    },

    getValidateData(data) {
      this.tabSelected = 0
      this.invalidRecords = []
      this.validRecors = []
      for (const d of data) {
        if (
          d.First_Name.length >= 2 &&
          d.Last_Name.length >= 2 &&
          this.validateEmail(d.EMAIL) &&
          this.getDubliacteRecords(d.EMAIL)
        ) {
          d.valid = true
          this.validRecors.push(d)
        } else {
          d.valid = false
          if (d.First_Name !== '') this.invalidRecords.push(d)
        }

        if (this.invalidRecords.length > this.validRecors.length)
          this.tabSelected = 1
      }
    },

    getHeaderArray(csvRecordsArr) {
      const headers = csvRecordsArr[0].split(',')
      const headerArray = []
      for (let j = 0; j < headers.length; j++) {
        headerArray.push(headers[j])
      }
      return headerArray
    },

    onFileChange(e) {},
    createInput(file) {
      var reader = new FileReader()
      var vm = this
      reader.onload = (e) => {
        vm.fileinput = reader.result
      }
      reader.readAsText(file)
    },

    changedLabel() {
      const data = this.items.find((x) => x.id === this.selectedOrg)
      this.desserts = []
      this.desserts.push(data)
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.postData()
      }
    },

    validateUser() {
      this.errorFlag = true

      this.$refs.form.validate()
      if (
        this.valid &&
        this.environmentSelected &&
        this.selectedOrg &&
        this.hbpSecretKey
      ) {
        this.errorFlag = false
        this.invalidFileMessage = null
        if (this.isProvider) this.importSingleProvider()
        else this.importSingleUsers()
      }
    },

    importSingleUsers() {
      this.dialogSmall = false
      const userObj = []

      for (const userDetails of this.userDetailsArray)
        userObj.push({
          first_name: userDetails.firstName,
          last_name: userDetails.lastName,
          DOB: moment(userDetails.dob).format('YYYY-MM-DD'),
          GENDER:
            userDetails.gender === 'Male' || userDetails.gender === 'M'
              ? 'M'
              : 'F',
          EMAIL: userDetails.email,
        })

      const obj = {
        organizationid: this.selectedOrg,
        hbp_secret_key: this.hbpSecretKey,
        users: userObj,
      }
      this.startLoader()
      var url
      if (this.environmentSelected !== 'prod')
        url = `https://${this.environmentSelected}.myhealthbookplus.com/api/v1/csvusers/importusers/`
      else url = `https://myhealthbookplus.com/api/v1/csvusers/importusers/`

      axios
        .post(url, obj)
        .then((res) => {
          this.stopLoader()
          if (res.data.success === true) {
            this.importResponce = res.data

            this.confirmPopup = 'confirm'
            this.dialogSmallLogo = true
            this.successMessage = 'User added successfully'

            this.userDetailsArray = []
            this.$refs.form.reset()
            this.addPatient()
          }
        })
        .catch((err) => {
          this.stopLoader()
          console.warn(err.response.data)
          this.invalidFile = true
          this.invalidFileMessage = '* ' + err.response.data
        })
    },

    importSingleProvider() {
      this.dialogSmall = false
      const userObj = []

      for (const userDetails of this.providerDetailsArray)
        userObj.push({
          first_name: userDetails.firstName,
          last_name: userDetails.lastName,
          DOB: moment(userDetails.dob).format('YYYY-MM-DD'),
          GENDER:
            userDetails.gender === 'Male' || userDetails.gender === 'M'
              ? 'M'
              : 'F',
          EMAIL: userDetails.email,

          credential: [{ cred: userDetails.credential }],
          npi_number: userDetails.npi_number,
          speciality: userDetails.speciality,
          address_line_1: userDetails.address_line_1,
          city: userDetails.city,
          zip_code: userDetails.zip_code,
          state: userDetails.state,
          phone_number: userDetails.phone_number.replace('-', ''),
          doxy_me_link: userDetails.doxy_me_link,
          is_active_peer_coaching: userDetails.is_active_peer_coaching,
          biography: userDetails.biography,
          is_active_telehealth_consultation:
            userDetails.is_active_telehealth_consultation,
          is_admin: userDetails.is_admin,
        })

      const obj = {
        organizationid: this.selectedOrg,
        hbp_secret_key: this.hbpSecretKey,
        users: userObj,
      }

      this.startLoader()
      var url

      if (this.environmentSelected !== 'prod')
        url = `https://provider-portal-${this.environmentSelected}.myhealthbookplus.com/api/v1/importproviderdetails/`
      else
        url = `https://provider-portal.myhealthbookplus.com/api/v1/importproviderdetails/`

      axios
        .post(url, obj)
        .then((res) => {
          this.stopLoader()
          if (res.data.success === true) {
            this.importResponce = res.data

            this.confirmPopup = 'confirm'
            this.dialogSmallLogo = true
            this.successMessage = 'Provider added successfully'
            this.providerDetailsArray = []
            this.$refs.form.reset()
            this.addProvider()
          }
        })
        .catch((err) => {
          this.stopLoader()
          console.warn(err.response.data)
          this.invalidFile = true
          this.invalidFileMessage = '* ' + err.response.data
        })
    },

    resetForm() {
      this.dialogReset = false
      this.errorMessage = null
      this.$refs.form.reset()
    },
    reset() {
      this.errorMessage = null
      this.$refs.form.reset()
    },
    reset1() {
      this.errorMessage = null
      this.$refs.form.reset()

      document.getElementById('closeButton1').click()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getData() {
      axios
        .get('https://dev.myhealthbookplus.com/api/v1/organization_detail/')
        .then((res) => {
          this.authError = null
          this.items = [
            {
              id: 3,
              short_name: 'healthbook',
              full_name: 'HealthBook+',
              country: 'USA',
              logo: '',
              contact: 'lykourgos.tzardis@healthbookplus.com',
              insertts: '2021-12-30T09:53:03.442400Z',
              updatets: '2021-12-30T09:53:03.442427Z',
            },
          ]
          if (this.$route.params.clientId === 'provider') {
            this.isProvider = true
            this.breadCrumbs = [
              {
                text: 'Home',
                disabled: true,
                href: 'breadcrumbs_dashboard',
              },
              {
                text: 'Add Provider',
                disabled: true,
                href: 'breadcrumbs_link_1',
              },
            ]
          } else {
            if (this.$route.params.clientId === 'patient') {
              this.breadCrumbs = [
                {
                  text: 'Home',
                  disabled: true,
                  href: 'breadcrumbs_dashboard',
                },
                {
                  text: 'Add User',
                  disabled: true,
                  href: 'breadcrumbs_link_1',
                },
              ]
            } else {
              this.breadCrumbs = [
                {
                  text: 'Home',
                  disabled: false,
                  href: 'breadcrumbs_dashboard',
                },
                {
                  text: 'Add User',
                  disabled: true,
                  href: 'breadcrumbs_link_1',
                },
              ]
            }
            this.changedLabel()
          }
        })
    },
    postData() {
      this.errorMessage = null
      const obj = {
        contact: this.organization.contact,
        country: this.organization.country,
        full_name: this.organization.name,
        short_name: this.organization.shortname,
        logo: this.organization.logo,
      }
      axios
        .post(
          'https://dev.myhealthbookplus.com/api/v1/create_organization/',
          obj
        )
        .then(
          (res) => {
            this.successOrganizationButtonClick()
            this.reset()
            this.getData()
          },
          (err) => {
            this.errorMessage = err.response.data.contact[0]
          }
        )
    },

    addOrganizationButtonClick() {
      this.dialogSmallLogo = false
      document.getElementById('addOrganizationButton').click()
    },

    successOrganizationButtonClick() {
      this.confirmPopup = 'confirm'
      this.dialogSmallLogo = true
      this.successMessage = 'Organization craeted successfully'
    },

    importProvider() {
      this.errorFlag = true
      this.dialogSmall = false
      if (this.environmentSelected && this.selectedOrg && this.hbpSecretKey) {
        const userObj = []
        for (const d of this.validRecors) {
          userObj.push({
            first_name: d.First_Name,
            last_name: d.Last_Name,

            DOB: moment(d.DOB).format('YYYY-MM-DD'),
            GENDER: d.GENDER === 'Male' || d.GENDER === 'M' ? 'M' : 'F',
            EMAIL: d.EMAIL,

            credential: [{ cred: d.credential }],
            npi_number: d.npi_number,
            speciality: d.speciality,
            address_line_1: d.address_line_1,
            city: d.city,
            zip_code: d.zip_code,
            state: d.state,
            phone_number: d.phone_number,
            doxy_me_link: d.doxy_me_link,
            is_active_peer_coaching: d.is_active_peer_coaching === 'TRUE',
            biography: d.biography,
            is_active_telehealth_consultation:
              d.is_active_telehealth_consultation === 'TRUE',
            is_admin: d.is_admin === 'TRUE',
          })
        }

        const obj = {
          organizationid: this.selectedOrg,
          hbp_secret_key: this.hbpSecretKey,
          users: userObj,
        }

        this.startLoader()
        var url

        if (this.environmentSelected !== 'prod')
          url = `https://provider-portal-${this.environmentSelected}.myhealthbookplus.com/api/v1/importproviderdetails/`
        else
          url = `https://provider-portal.myhealthbookplus.com/api/v1/importproviderdetails/`

        axios
          .post(url, obj)
          .then((res) => {
            this.stopLoader()
            if (res.data.success === true) {
              this.confirmPopup = 'confirm'
              this.dialogSmallLogo = true
              this.successMessage = 'Provider added successfully'
              this.importResponce = res.data

              for (const d in this.importResponce.save_data) {
                this.importResponce.save_data[d] = {
                  EMAIL: this.importResponce.save_data[d].substring(6),
                }
              }
              for (const d in this.importResponce.existing_emails) {
                this.importResponce.existing_emails[d] = {
                  EMAIL: this.importResponce.existing_emails[d].substring(6),
                }
              }
              for (const d in this.importResponce.existingemails) {
                this.importResponce.existingemails[d] = {
                  EMAIL: this.importResponce.existingemails[d].substring(6),
                }
              }

              this.tabSelected = 2
            }
          })
          .catch((err) => {
            this.stopLoader()
            console.warn(err.response.data)
            this.invalidFile = true
            this.invalidFileMessage = '* ' + err.response.data
          })
      }
    },

    importUsers() {
      this.errorFlag = true
      this.dialogSmall = false
      if (this.environmentSelected && this.selectedOrg && this.hbpSecretKey) {
        this.errorFlag = false

        const userObj = []
        for (const d of this.validRecors) {
          userObj.push({
            first_name: d.First_Name,
            last_name: d.Last_Name,
            DOB: moment(new Date(d.DOB)).format('YYYY-MM-DD'),
            GENDER: d.GENDER === 'Male' || d.GENDER === 'M' ? 'M' : 'F',
            EMAIL: d.EMAIL,
          })
        }

        const obj = {
          organizationid: this.selectedOrg,
          hbp_secret_key: this.hbpSecretKey,
          users: userObj,
        }

        this.startLoader()
        var url
        if (this.environmentSelected !== 'prod')
          url = `https://${this.environmentSelected}.myhealthbookplus.com/api/v1/csvusers/importusers/`
        else url = `https://myhealthbookplus.com/api/v1/csvusers/importusers/`

        axios
          .post(url, obj)
          .then((res) => {
            this.stopLoader()
            if (res.data.success === true) {
              this.importResponce = res.data

              for (const d in this.importResponce.saveuserdata) {
                this.importResponce.saveuserdata[d] = {
                  EMAIL: this.importResponce.saveuserdata[d].substring(6),
                }
              }
              for (const d in this.importResponce.existinguseremail) {
                this.importResponce.existinguseremail[d] = {
                  EMAIL: this.importResponce.existinguseremail[d].substring(6),
                }
              }
              for (const d in this.importResponce.existingemails) {
                this.importResponce.existingemails[d] = {
                  EMAIL: this.importResponce.existingemails[d].substring(6),
                }
              }
              this.tabSelected = 2
            }
          })
          .catch((err) => {
            this.stopLoader()
            console.warn(err.response.data)
            this.invalidFile = true
            this.invalidFileMessage = '* ' + err.response.data
          })
      }
    },

    importUsersActive() {
      this.importMultiple = !this.importMultiple
    },
  },
}
</script>

<template>
  <div>
    <v-dialog v-model="dialogSmallLogo" persistent max-width="290">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          style="display: none"
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Add Organization
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5"> Success </v-card-title>
        <v-card-text>{{ successMessage }}.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogSmallLogo = false">
            Okay
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="openReasonDialog" persistent max-width="360">
      <v-card>
        <v-card-title>
          <span class="text-h5">Reason</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="reasonText"
                outlined
                value=""
                label=""
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="card-action-center">
          <v-btn
            depressed
            class="btn-reasons"
            :loading="false"
            @click="handleConfirmReason"
          >
            Confirm
          </v-btn>
          <v-divider vertical class="btn-divider"></v-divider>
          <v-btn depressed class="btn-reasons" @click="handleCancelReason">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div style="margin: 0 auto; overflow: hidden">
      <v-card class="orgClassCard">
        <v-tabs v-model="activeTab" class="tabStyling" @change="changeTabs">
          <v-tab>Add {{ isProvider ? 'Provider' : 'User' }}</v-tab>
          <v-tab>Search</v-tab>
        </v-tabs>
        <div v-if="activeTab === 0">
          <div v-if="!isProvider">
            <v-row>
              <v-col><h3 class="mb-20">Add User to Organization</h3></v-col>
            </v-row>
            <v-row>
              <h6 class="pa-4">Environment*:</h6>

              <v-radio-group
                v-model="environmentSelected"
                class="pa-4"
                row
                style="margin-top: -5px"
                @change="changeEnvPatient"
              >
                <v-radio
                  style="padding: 0 20px"
                  label="Dev"
                  color="primary"
                  value="dev"
                ></v-radio>
                <v-radio
                  style="padding: 0 20px"
                  label="QA"
                  color="primary"
                  value="qa"
                ></v-radio>
                <v-radio
                  style="padding: 0 20px"
                  label="Stage"
                  color="primary"
                  value="stage"
                ></v-radio>
                <v-radio
                  style="padding: 0 20px"
                  label="Prod"
                  color="primary"
                  value="prod"
                ></v-radio>
              </v-radio-group>
            </v-row>
            <div
              v-if="errorFlag && !environmentSelected"
              style="margin-top: -20px; font-size: 12px; color: red"
              >*Please Select Enviroment</div
            >
            <div>
              <v-row style="padding: 30px">
                <v-col cols="5" style="text-align: end">
                  <v-btn
                    id="addOrganizationButton"
                    color="primary"
                    @click=";(importMultiple = 'single'), addUser()"
                    >Add User</v-btn
                  >
                </v-col>
                <v-col
                  cols="2"
                  style="display: inline-flex; justify-content: center"
                >
                  <div
                    style="
                      width: fit-content;
                      padding: 8px;
                      background: #ccc;
                      border-radius: 50%;
                    "
                  >
                    OR
                  </div>
                </v-col>
                <v-col cols="5">
                  <v-btn
                    id="addOrganizationButton"
                    color="primary"
                    @click=";(importMultiple = 'multiple'), addUser()"
                    >Bulk Upload</v-btn
                  >
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col v-if="!isProvider" class="d-flex" cols="4" sm="4">
                <v-select
                  v-model="selectedOrg"
                  style="margin-top: 25px"
                  :items="items"
                  item-value="id"
                  item-text="full_name"
                  name="OrganizatioSelect"
                  label="Select Organization*"
                  :disabled="!environmentSelected"
                  dense
                  solo
                ></v-select>
              </v-col>

              <v-col v-if="isProvider" class="d-flex" cols="4" sm="4">
                <v-select
                  v-model="selectedOrg"
                  style="margin-top: 25px"
                  :items="providerItems"
                  item-value="id"
                  item-text="full_name"
                  name="OrganizatioSelect"
                  label="Select Organization*"
                  :disabled="!environmentSelected"
                  dense
                  solo
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <div
                v-if="errorFlag && !selectedOrg"
                style="margin-top: -35px; font-size: 12px; color: red"
                >*Please Select Organization</div
              >
            </v-row>

            <div v-if="importMultiple === 'multiple'">
              <v-file-input
                type="file"
                accept=".csv , application/vnd.ms-excel , application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                label="Please input csv file*"
                @change="uploadFile"
              ></v-file-input>

              <v-row>
                <v-col cols="7" style="padding: 10px 45px">
                  <v-text-field
                    v-model="hbpSecretKey"
                    label="Secret Key*"
                    required
                    :disabled="validRecors.length === 0"
                  ></v-text-field>
                </v-col>
              </v-row>
              <div
                v-if="errorFlag && !hbpSecretKey"
                style="margin-top: -20px; font-size: 12px; color: red"
                >*Please fill secret key</div
              >

              <template>
                <v-tabs v-model="tabSelected" grow>
                  <v-tab
                    v-for="tab of tabs"
                    :key="tab.index"
                    :disabled="
                      (tab.index === 2 && !importResponce) ||
                      (tab.index !== 2 && importResponce)
                    "
                    @click="tabSelected = tab.index"
                  >
                    {{ tab.name }}
                  </v-tab>
                </v-tabs>
              </template>

              <v-data-table
                v-if="tabSelected === 1"
                style="color: red"
                :headers="userHeader"
                :items="invalidRecords"
                class="elevation-1"
              ></v-data-table>

              <v-data-table
                v-else-if="tabSelected === 0"
                style="color: green"
                :headers="userHeader"
                :items="validRecors"
                class="elevation-1"
              ></v-data-table>

              <div v-else-if="tabSelected === 2">
                <v-data-table
                  style="color: green"
                  :headers="responseHeaderSaved"
                  :items="importResponce.saveuserdata"
                  class="elevation-1"
                ></v-data-table>
                <v-data-table
                  :headers="responseHeaderexistingemails"
                  :items="importResponce.existingemails"
                  class="elevation-1"
                ></v-data-table>
                <v-data-table
                  :headers="responseHeaderexistinguseremail"
                  :items="importResponce.existinguseremail"
                  class="elevation-1"
                ></v-data-table>
              </div>
              <span v-if="invalidFile" style="color: red">{{
                invalidFileMessage
              }}</span>
              <div justify="center" style="margin: 10px; text-align: end">
                <v-dialog v-model="dialogSmall" persistent max-width="480">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="disabledButton"
                      :disabled="!submitButtonimport || isVisible"
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      Submit
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="text-h5"> Confirm </v-card-title>
                    <v-card-text
                      >Are you sure you want to save
                      <span style="font-weight: bold; color: green">{{
                        validRecors.length
                      }}</span>
                      valid records & discard invalid record
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="green darken-1"
                        text
                        @click="dialogSmall = false"
                      >
                        No
                      </v-btn>
                      <v-btn color="green darken-1" text @click="importUsers">
                        Yes
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </div>
            <div v-else-if="importMultiple === 'single'">
              <v-row justify="center"> </v-row>

              <template>
                <v-card
                  style="height: 570px; margin-top: 30px; overflow: hidden"
                >
                  <v-row>
                    <v-btn
                      style="
                        right: 20px;
                        z-index: 1;
                        display: block;
                        margin-top: 20px;
                        color: white;
                        background: #0476d9;
                        margin-inline-start: auto;
                      "
                      class="mr-4"
                      @click="addPatient"
                    >
                      Add Row
                    </v-btn>
                  </v-row>

                  <div style="height: 350px; overflow: scroll">
                    <v-form ref="form" v-model="valid">
                      <v-card-text
                        v-for="(userDetails, index) in userDetailsArray"
                        :key="index"
                        style="padding: 0"
                      >
                        <template>
                          <v-row no-gutters style="margin-right: -180px">
                            <v-col cols="2" class="pa-4">
                              <v-text-field
                                v-model="userDetails.firstName"
                                :maxlength="30"
                                :rules="nameRules"
                                label="First Name*"
                                required
                              ></v-text-field>
                            </v-col>
                            <v-col cols="2" class="pa-4">
                              <v-text-field
                                v-model="userDetails.lastName"
                                :maxlength="30"
                                :rules="nameRules"
                                label="Last Name*"
                                required
                              ></v-text-field>
                            </v-col>
                            <v-col cols="2" class="pa-4">
                              <v-menu
                                v-model="userDetails.menu2"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="auto"
                                @click="openPopUp(userDetails.dob)"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="userDetails.dob"
                                    label="Date Of Birth*"
                                    hint="MM/DD/YYYY"
                                    persistent-hint
                                    append-icon="mdi-calendar"
                                    v-bind="attrs"
                                    :rules="dobRule"
                                  >
                                  </v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="userDetails.dob"
                                  no-title
                                  @input="
                                    ;(userDetails.menu2 = false),
                                      (userDetails.dob = parseDate(
                                        // eslint-disable-next-line vue/comma-dangle
                                        userDetails.dob
                                      ))
                                  "
                                >
                                </v-date-picker>
                              </v-menu>
                            </v-col>

                            <v-col cols="2" class="pa-4">
                              <v-select
                                v-model="userDetails.gender"
                                class="drpdownClass"
                                style="margin-top: 10px"
                                :items="genderDD"
                                :rules="logoRules"
                                item-value="key"
                                item-text="name"
                                label="Gender*"
                                dense
                                solo
                              ></v-select>
                            </v-col>

                            <v-col cols="2" class="pa-4">
                              <v-text-field
                                v-model="userDetails.email"
                                :rules="emailRules"
                                label="Email*"
                                required
                              ></v-text-field>
                            </v-col>

                            <v-col cols="2" class="pa-4">
                              <v-btn
                                icon
                                style="margin-top: 15px"
                                @click="cancelRow(index)"
                              >
                                <v-icon style="font-size: 30px"
                                  >mdi-close-circle-outline</v-icon
                                >
                              </v-btn>
                            </v-col>
                          </v-row>

                          <div
                            v-if="errorMessage"
                            style="margin-bottom: 20px; color: red"
                            >*{{ errorMessage }}</div
                          >
                        </template>
                      </v-card-text>
                    </v-form>
                  </div>

                  <v-row style="padding: 0 10px">
                    <v-col cols="4" class="pa-4">
                      <v-text-field
                        v-model="hbpSecretKey"
                        label="Secret Key*"
                        required
                      ></v-text-field>

                      <v-spacer></v-spacer>
                    </v-col>
                  </v-row>
                  <div
                    v-if="errorFlag && !hbpSecretKey"
                    style="margin-top: -20px; font-size: 12px; color: red"
                    >*Please fill secret key</div
                  >
                  <span v-if="invalidFile" style="color: red">{{
                    invalidFileMessage
                  }}</span>

                  <v-row style="justify-content: end; margin-top: 3px">
                    <v-dialog v-model="dialogReset" persistent max-width="290">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          style="display: block; color: white"
                          color="red"
                          class="mr-4"
                          v-bind="attrs"
                          v-on="on"
                        >
                          Reset
                        </v-btn>
                      </template>

                      <v-card>
                        <v-card-title class="text-h5"> Reset </v-card-title>
                        <v-card-text
                          >Your data will not get recoverd.<br />Are you sure
                          you want to continue?</v-card-text
                        >
                        <v-card-actions>
                          <v-spacer></v-spacer>

                          <v-btn
                            color="black darken-1"
                            text
                            @click="dialogReset = false"
                          >
                            No
                          </v-btn>
                          <v-btn
                            color="black darken-1"
                            text
                            @click="resetPatientForm"
                          >
                            Yes
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <v-btn
                      style="display: block; color: white; background: #0476d9"
                      :disabled="!submitButton || isVisible"
                      class="mr-4"
                      @click="validateUser"
                    >
                      Submit
                    </v-btn>
                  </v-row>

                  <v-card-actions class="justify-end" style="display: none">
                    <v-btn
                      id="closeButton1"
                      text
                      @click=";(dialog.value = false), reset"
                      >Close</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </template>
            </div>
          </div>

          <div v-if="isProvider">
            <v-row>
              <h3 class="mb-20">Add Provider to Organization</h3>
            </v-row>

            <v-row>
              <h6 class="pa-4">Environment*:</h6>
              <v-radio-group
                v-model="environmentSelected"
                class="pa-4"
                row
                style="margin-top: -5px"
                @change="changeEnv"
              >
                <v-radio
                  style="padding: 0 20px"
                  label="Dev"
                  color="primary"
                  value="dev"
                ></v-radio>
                <v-radio
                  style="padding: 0 20px"
                  label="QA"
                  color="primary"
                  value="qa"
                ></v-radio>
                <v-radio
                  style="padding: 0 20px"
                  label="Stage"
                  color="primary"
                  value="stage"
                ></v-radio>
                <v-radio
                  style="padding: 0 20px"
                  label="Prod"
                  color="primary"
                  value="prod"
                ></v-radio>
              </v-radio-group>
            </v-row>
            <div
              v-if="errorFlag && !environmentSelected"
              style="margin-top: -20px; font-size: 12px; color: red"
              >*Please Select Enviroment</div
            >
            <div>
              <v-row style="padding: 30px">
                <v-col cols="5" style="text-align: end">
                  <v-btn
                    id="addOrganizationButton"
                    color="primary"
                    @click=";(importMultiple = 'single'), addUser()"
                    >Add Provider</v-btn
                  >
                </v-col>
                <v-col
                  cols="2"
                  style="display: inline-flex; justify-content: center"
                >
                  <div
                    style="
                      width: fit-content;
                      padding: 8px;
                      background: #ccc;
                      border-radius: 50%;
                    "
                  >
                    OR</div
                  >
                </v-col>
                <v-col cols="5">
                  <v-btn
                    id="addOrganizationButton"
                    color="primary"
                    @click=";(importMultiple = 'multiple'), addUser()"
                    >Bulk Upload</v-btn
                  >
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col v-if="!isProvider" class="d-flex" cols="4" sm="4">
                <v-select
                  v-model="selectedOrg"
                  style="margin-top: 25px"
                  :items="items"
                  item-value="id"
                  item-text="full_name"
                  name="OrganizatioSelect"
                  :disabled="!environmentSelected"
                  label="Select Organization*"
                  dense
                  solo
                ></v-select>
              </v-col>

              <v-col v-if="isProvider" class="d-flex" cols="4" sm="4">
                <v-select
                  v-model="selectedOrg"
                  style="margin-top: 25px"
                  :items="providerItems"
                  item-value="id"
                  item-text="full_name"
                  name="OrganizatioSelect"
                  label="Select Organization*"
                  dense
                  solo
                  :disabled="!environmentSelected"
                  @change="changedLabel"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <div
                v-if="errorFlag && !selectedOrg"
                style="margin-top: -35px; font-size: 12px; color: red"
                >*Please Select Organization</div
              >
            </v-row>
            <div v-if="importMultiple === 'multiple'">
              <v-file-input
                type="file"
                accept=".csv , application/vnd.ms-excel , application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                label="Please input csv file"
                @change="uploadFile"
              ></v-file-input>

              <v-row>
                <v-col cols="7" style="padding: 10px 45px">
                  <v-text-field
                    v-model="hbpSecretKey"
                    label="Secret Key*"
                    required
                    :disabled="validRecors.length === 0"
                  ></v-text-field>
                </v-col>
              </v-row>
              <div
                v-if="errorFlag && !hbpSecretKey"
                style="margin-top: -20px; font-size: 12px; color: red"
                >*Please fill secret key</div
              >

              <template>
                <v-tabs v-model="tabSelected" grow>
                  <v-tab
                    v-for="tab of tabs"
                    :key="tab.index"
                    :disabled="
                      (tab.index === 2 && !importResponce) ||
                      (tab.index !== 2 && importResponce)
                    "
                    @click="tabSelected = tab.index"
                  >
                    {{ tab.name }}
                  </v-tab>
                </v-tabs>
              </template>

              <v-data-table
                v-if="tabSelected === 1"
                style="color: red"
                :headers="userHeaderProvider"
                :items="invalidRecords"
                class="elevation-1"
              ></v-data-table>

              <v-data-table
                v-else-if="tabSelected === 0"
                style="color: green"
                :headers="userHeaderProvider"
                :items="validRecors"
                class="elevation-1"
              ></v-data-table>

              <div v-else-if="tabSelected === 2">
                <v-data-table
                  style="color: green"
                  :headers="responseHeaderSaved"
                  :items="importResponce.save_data"
                  class="elevation-1"
                ></v-data-table>
                <v-data-table
                  :headers="responseHeaderexistingemails"
                  :items="importResponce.existing_emails"
                  class="elevation-1"
                ></v-data-table>
              </div>
              <span v-if="invalidFile" style="color: red">{{
                invalidFileMessage
              }}</span>

              <div justify="center" style="margin: 10px; text-align: end">
                <v-dialog v-model="dialogSmall" persistent max-width="480">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="disabledButton"
                      :disabled="!submitButtonimport || isVisible"
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      Submit
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="text-h5"> Confirm </v-card-title>
                    <v-card-text
                      >Are you sure you want to save
                      <span style="font-weight: bold; color: green">{{
                        validRecors.length
                      }}</span>
                      valid records & discard invalid record
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="green darken-1"
                        text
                        @click="dialogSmall = false"
                      >
                        No
                      </v-btn>
                      <v-btn
                        color="green darken-1"
                        text
                        @click="importProvider"
                      >
                        Yes
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </div>
            <div v-if="importMultiple === 'single'">
              <v-card style="height: 530px; overflow: hidden">
                <v-row>
                  <v-btn
                    style="
                      right: 20px;
                      z-index: 1;
                      display: block;
                      margin-top: 20px;
                      color: white;
                      background: #0476d9;
                      margin-inline-start: auto;
                    "
                    class="mr-4"
                    @click="addProvider"
                  >
                    Add Row
                  </v-btn>
                </v-row>
                <div style="height: 350px; overflow: scroll">
                  <v-form ref="form" v-model="valid">
                    <v-card-text
                      v-for="(userDetails, index) in providerDetailsArray"
                      :key="index"
                      style="padding: 0"
                    >
                      <template>
                        <v-row no-gutters style="width: max-content">
                          <div class="pa-4" style="width: 200px">
                            <v-text-field
                              v-model="userDetails.firstName"
                              :maxlength="30"
                              :rules="nameRules"
                              label="First Name*"
                              required
                            ></v-text-field>
                          </div>
                          <div class="pa-4" style="width: 200px">
                            <v-text-field
                              v-model="userDetails.lastName"
                              :rules="nameRules"
                              :maxlength="30"
                              label="Last Name*"
                              required
                            ></v-text-field>
                          </div>
                          <div class="pa-4" style="width: 200px">
                            <v-menu
                              v-model="userDetails.menu2"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="userDetails.dob"
                                  label="Date Of Birth*"
                                  persistent-hint
                                  hint="MM/DD/YYYY"
                                  append-icon="mdi-calendar"
                                  v-bind="attrs"
                                  :rules="dobRule"
                                >
                                </v-text-field>
                              </template>
                              <v-date-picker
                                v-model="userDetails.dob"
                                no-title
                                @input="userDetails.menu2 = false"
                              >
                              </v-date-picker>
                            </v-menu>
                          </div>
                          <div class="pa-4" style="width: 200px">
                            <v-select
                              v-model="userDetails.gender"
                              class="drpdownClass"
                              style="margin-top: 10px"
                              :items="genderDD"
                              :rules="logoRules"
                              item-value="key"
                              item-text="name"
                              label="Gender*"
                              dense
                              solo
                            ></v-select>
                          </div>

                          <div class="pa-4" style="width: 200px">
                            <v-text-field
                              v-model="userDetails.email"
                              :rules="emailRules"
                              label="Email*"
                              required
                            ></v-text-field>
                          </div>

                          <div class="pa-4" style="width: 200px">
                            <v-select
                              v-model="userDetails.credential"
                              class="drpdownClass"
                              style="margin-top: 10px"
                              :items="credentials"
                              item-value="credential_name"
                              item-text="credential_name"
                              label="Credentials*"
                              :rules="nameRules"
                              dense
                              solo
                            ></v-select>
                          </div>

                          <div class="pa-4" style="width: 200px">
                            <v-text-field
                              v-model="userDetails.npi_number"
                              :rules="npiRule"
                              label="NPI Number*"
                              :maxlength="10"
                              required
                              @keypress="isNotLetter($event)"
                            ></v-text-field>
                          </div>

                          <div class="pa-4" style="width: 200px">
                            <v-select
                              v-model="userDetails.speciality"
                              class="drpdownClass"
                              style="margin-top: 10px"
                              :items="speciality"
                              item-value="speciality_name"
                              item-text="speciality_name"
                              label="Speciality*"
                              :rules="nameRules"
                              dense
                              solo
                            ></v-select>
                          </div>

                          <div class="pa-4" style="width: 200px">
                            <v-text-field
                              v-model="userDetails.address_line_1"
                              label="Address*"
                              :rules="nameRules"
                              :maxlength="100"
                              required
                            ></v-text-field>
                          </div>

                          <div class="pa-4" style="width: 200px">
                            <v-text-field
                              v-model="userDetails.city"
                              label="City*"
                              :rules="nameRules"
                              :maxlength="30"
                              reuired
                              @keypress="isLetter($event)"
                            ></v-text-field>
                          </div>

                          <div class="pa-4" style="width: 200px">
                            <v-text-field
                              v-model="userDetails.zip_code"
                              :rules="zipRule"
                              :minlength="5"
                              :maxlength="10"
                              label="Zip*"
                              required
                              @keypress="isNotLetter($event)"
                            ></v-text-field>
                          </div>

                          <div class="pa-4" style="width: 200px">
                            <v-select
                              v-model="userDetails.state"
                              class="drpdownClass"
                              style="margin-top: 10px"
                              :items="states"
                              item-value="value"
                              item-text="value"
                              label="State*"
                              :rules="nameRules"
                              dense
                              solo
                            ></v-select>
                          </div>

                          <div class="pa-4" style="width: 300px">
                            <v-text-field
                              v-model="userDetails.phone_number"
                              v-mask="['+1 ###-###-####']"
                              label="Phone Number*"
                              :rules="phoneRule"
                              required
                              @keydown="acceptNumber"
                            ></v-text-field>
                          </div>

                          <div class="pa-4" style="width: 200px">
                            <v-text-field
                              v-model="userDetails.doxy_me_link"
                              label="Doxy Link*"
                              required
                              :rules="doxyRule"
                            ></v-text-field>
                          </div>

                          <div class="pa-4">
                            <v-switch
                              v-model="userDetails.is_active_peer_coaching"
                              label="Available for secure chat"
                              color="secondary"
                              hide-details
                            ></v-switch>
                          </div>

                          <div class="pa-4">
                            <v-switch
                              v-model="
                                userDetails.is_active_telehealth_consultation
                              "
                              label="Available for telehealth consultation"
                              color="secondary"
                              hide-details
                            ></v-switch>
                          </div>

                          <div class="pa-4">
                            <v-switch
                              v-model="userDetails.is_admin"
                              label="Is Admin"
                              color="secondary"
                              hide-details
                            ></v-switch>
                          </div>

                          <div class="pa-4">
                            <v-btn
                              icon
                              style="margin-top: 15px"
                              @click="cancelRowProvider(index)"
                            >
                              <v-icon style="font-size: 30px"
                                >mdi-close-circle-outline</v-icon
                              >
                            </v-btn>
                          </div>
                        </v-row>

                        <div
                          v-if="errorMessage"
                          style="margin-bottom: 20px; color: red"
                          >*{{ errorMessage }}</div
                        >
                      </template>
                    </v-card-text>
                  </v-form>
                </div>

                <v-row>
                  <v-col cols="4" class="pa-4" style="width: 200px">
                    <v-text-field
                      v-model="hbpSecretKey"
                      label="Secret Key*"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <div
                  v-if="errorFlag && !hbpSecretKey"
                  style="margin-top: -20px; font-size: 12px; color: red"
                  >*Please fill secret key</div
                >

                <span v-if="invalidFile" style="color: red">{{
                  invalidFileMessage
                }}</span>

                <v-row style="justify-content: end">
                  <v-dialog v-model="dialogReset" persistent max-width="290">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        style="display: block; color: white"
                        color="red"
                        class="mr-4"
                        v-bind="attrs"
                        v-on="on"
                      >
                        Reset
                      </v-btn>
                    </template>

                    <v-card>
                      <v-card-title class="text-h5"> Rsest </v-card-title>
                      <v-card-text
                        >Your data will not get recoverd.<br />Are you sure you
                        want to continue?</v-card-text
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                          color="black darken-1"
                          text
                          @click="dialogReset = false"
                        >
                          No
                        </v-btn>
                        <v-btn
                          color="black darken-1"
                          text
                          @click="resetFormProvider"
                        >
                          Yes
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-btn
                    style="display: block; color: white; background: #0476d9"
                    :disabled="!submitButton || isVisible"
                    class="mr-4"
                    @click="validateUser"
                  >
                    Submit
                  </v-btn>
                </v-row>
                <v-card-actions class="justify-end" style="display: none">
                  <v-btn
                    id="closeButton1"
                    text
                    @click=";(dialog.value = false), reset"
                    >Close</v-btn
                  >
                </v-card-actions>
              </v-card>
            </div>
          </div>
        </div>
        <div v-if="activeTab === 1">
          <v-row>
            <h6 class="pa-4">Environment*:</h6>

            <v-radio-group
              v-model="environmentSelectedSearch"
              class="pa-4"
              row
              style="margin-top: -5px"
              @change="changeEnvSearch"
            >
              <v-radio
                style="padding: 0 20px"
                label="Dev"
                color="primary"
                value="dev"
              ></v-radio>
              <v-radio
                style="padding: 0 20px"
                label="QA"
                color="primary"
                value="qa"
              ></v-radio>
              <v-radio
                style="padding: 0 20px"
                label="Stage"
                color="primary"
                value="stage"
              ></v-radio>
              <v-radio
                style="padding: 0 20px"
                label="Prod"
                color="primary"
                value="prod"
              ></v-radio>
            </v-radio-group>
          </v-row>
          <div
            v-if="errorFlag && !environmentSelectedSearch"
            style="margin-top: -20px; font-size: 12px; color: red"
            >*Please Select Enviroment</div
          >

          <v-row>
            <v-col v-if="!isProvider" class="d-flex" cols="4" sm="4">
              <v-select
                v-model="selectedOrgSearch"
                style="margin-top: 25px"
                :items="items"
                item-value="id"
                item-text="full_name"
                name="OrganizatioSelect"
                label="Select Organization*"
                dense
                solo
                :disabled="!environmentSelectedSearch"
              ></v-select>
            </v-col>

            <v-col v-if="isProvider" class="d-flex" cols="4" sm="4">
              <v-select
                v-model="selectedOrgSearch"
                style="margin-top: 25px"
                :items="providerItems"
                item-value="id"
                item-text="full_name"
                name="OrganizatioSelect"
                label="Select Organization*"
                dense
                solo
                :disabled="!environmentSelectedSearch"
                @change="changedLabel"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <div
              v-if="errorFlag && !selectedOrgSearch"
              style="margin-top: -35px; font-size: 12px; color: red"
              >*Please Select Organization</div
            >
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="hbpSecretKey"
                label="Secret Key*"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <div
              v-if="errorFlag && !hbpSecretKey"
              style="margin-top: -35px; font-size: 12px; color: red"
              >*Please fill secret key</div
            >
          </v-row>
          <v-form ref="form" v-model="valid">
            <v-card-text style="min-height: 350px; padding: 0">
              <template>
                <v-row no-gutters>
                  <v-col cols="2" class="pa-4">
                    <v-text-field
                      v-model="searchDetails.first_name"
                      :maxlength="30"
                      label="First Name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-4">
                    <v-text-field
                      v-model="searchDetails.last_name"
                      :maxlength="30"
                      label="Last Name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-4">
                    <v-menu
                      v-model="searchDetails.menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="searchDetails.dob"
                          label="Date Of Birth"
                          hint="MM/DD/YYYY"
                          persistent-hint
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          :rules="dobRule"
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="searchDetails.dob"
                        no-title
                        @input="
                          ;(userDetails.menu2 = false),
                            (userDetails.dob = parseDate(userDetails.dob))
                        "
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="2" class="pa-4">
                    <v-select
                      v-model="searchDetails.gender"
                      class="drpdownClass"
                      style="margin-top: 10px"
                      :items="genderDD"
                      item-value="key"
                      item-text="name"
                      label="Gender"
                      dense
                      solo
                    ></v-select>
                  </v-col>

                  <v-col cols="2" class="pa-4">
                    <v-text-field
                      v-model="searchDetails.email"
                      :rules="emailRulesNotReq"
                      label="Email"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="2" class="pa-4">
                    <v-btn style="margin-top: 15px" @click="searchUser"
                      >Search
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <span v-if="getSearchFormError" style="color: red">{{
                    getSearchFormError
                  }}</span>
                </v-row>

                <h5 class="labelClass">Search Results</h5>
                <template>
                  <div style="margin: 20px">
                    <v-data-table
                      :headers="
                        isProvider ? searchHeaderProvider : searchHeader
                      "
                      :items="searchResult"
                      class="elevation-2"
                      @click:row="openDetailsModal"
                    >
                      <template
                        v-slot:[`item.gender`]="{ item }"
                        @click="openDetailsModal"
                      >
                        {{ item.gender === 'F' ? 'Female' : 'Male' }}
                      </template>
                      <template v-slot:[`item.loading`]="{ item }">
                        <v-menu bottom left nudge-bottom="55">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="my-auto-Saafe"
                              icon
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>

                          <v-list class="py-0" dense>
                            <v-list-item
                              @click="
                                resultMenuAction('resend-access-code', item)
                              "
                            >
                              <v-list-item-title>
                                Resend Access Code
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              @click="
                                resultMenuAction('resend-confirm-email', item)
                              "
                            >
                              <v-list-item-title>
                                Resend Confirmation email
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              @click="resultMenuAction('reset-password', item)"
                            >
                              <v-list-item-title>
                                Reset Password
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              @click="resultMenuAction('remove-user', item)"
                            >
                              <v-list-item-title>Remove User</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              @click="resultMenuAction('suspend-user', item)"
                            >
                              <v-list-item-title>
                                Suspend User
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </template>
                      <template v-slot:[`item.isAdmin`]="{ item }" @click.stop>
                        <v-switch
                          v-model="item.is_admin"
                          label=""
                          color="secondary"
                          @click.stop
                          @change="changeAdmin($event, item)"
                        ></v-switch>
                      </template>
                    </v-data-table>
                  </div>
                </template>
              </template>
              <v-row>
                <div
                  v-if="errorFlagMsg"
                  style="margin-top: 25px; font-size: 12px; color: red"
                  >*{{ errorFlagMsg }}</div
                >
              </v-row>
            </v-card-text>
          </v-form>
        </div>
      </v-card>

      <template>
        <v-row justify="space-around"> </v-row>
      </template>

      <div v-if="isVisible" class="loader-overlay">
        <div class="loader"></div>
        <span class="text"></span>
      </div>
    </div>

    <v-dialog
      v-if="detailsModal && selectedSearchedUser"
      v-model="detailsModal"
      persistent
      max-width="600"
    >
      <template>
        <v-card class="pa-5">
          <v-card-text>
            <span class="dialogClose" @click="detailsModal = false">
              <v-icon>mdi-close</v-icon>
            </span>
            <v-row class="pa-1 pt-7">
              <v-col cols="3" class="ma-0 pa-0 boldFont"> First name: </v-col>
              <v-col cols="9" class="ma-0 pa-0">
                {{ selectedSearchedUser.first_name }}
              </v-col>
            </v-row>
            <v-row class="pa-1">
              <v-col cols="3" class="ma-0 pa-0 boldFont"> Last name: </v-col>
              <v-col cols="9" class="ma-0 pa-0">
                {{ selectedSearchedUser.last_name }}
              </v-col>
            </v-row>
            <v-row class="pa-1">
              <v-col cols="3" class="ma-0 pa-0 boldFont">
                Date of birth:
              </v-col>
              <v-col cols="9" class="ma-0 pa-0">
                {{ selectedSearchedUser.dob }}
              </v-col>
            </v-row>
            <v-row class="pa-1">
              <v-col cols="3" class="ma-0 pa-0 boldFont"> Gender: </v-col>
              <v-col cols="9" class="ma-0 pa-0">
                {{ selectedSearchedUser.gender === 'F' ? 'Female' : 'Male' }}
              </v-col>
            </v-row>
            <v-row class="pa-1">
              <v-col cols="3" class="ma-0 pa-0 boldFont"> Email: </v-col>
              <v-col cols="9" class="ma-0 pa-0">
                {{ selectedSearchedUser.email }}
              </v-col>
            </v-row>
            <v-row class="pa-1">
              <v-col cols="3" class="ma-0 pa-0 boldFont"> Status: </v-col>
              <v-col cols="9" class="ma-0 pa-0">
                {{ selectedSearchedUser.status }}
              </v-col>
            </v-row>
            <v-row class="pa-1">
              <v-col cols="3" class="ma-0 pa-0 boldFont"> Admin: </v-col>
              <v-col cols="9" class="ma-0 pa-0">
                {{ selectedSearchedUser.is_admin ? 'Yes' : 'No' }}
              </v-col>
            </v-row>
            <v-row class="pa-1">
              <v-col cols="3" class="ma-0 pa-0 boldFont"> Last login: </v-col>
              <v-col cols="9" class="ma-0 pa-0">
                {{ selectedSearchedUser.last_login }}
              </v-col>
            </v-row>
            <v-row class="pa-1">
              <v-col cols="3" class="ma-0 pa-0 boldFont">
                Last password change:
              </v-col>
              <v-col cols="9" class="ma-0 pa-0">
                {{ selectedSearchedUser.last_password_change }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<style lang="scss">
.boldFont {
  font-weight: 700;
  color: #000;
}

.dialogClose {
  position: absolute;
  top: 12px;
  right: 16.56px;
  width: 18.44px;
  height: 18.44px;
  color: #d1d1d1;
  cursor: pointer;
}

.labelClass {
  margin-top: 30px;
  margin-bottom: -20px;
}

.drpdownClass.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border-bottom: 1px solid #949494;
  border-radius: 0;
  box-shadow: none;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
  color: white !important;
  background-color: #d5d0d0 !important;
}

.admin_container_3djM8 {
  min-width: 100%;
  max-width: 100%;
  margin: 0 auto;
  background: none;
}

.orgClassCard {
  margin-top: 20px;
  box-shadow: none !important;
}

.loader-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.7);

  span.text {
    position: relative;
    top: 50%;
    left: 50%;
    display: inline-block;
    color: #fff;
    transform: translate(-50%, -50%);
  }

  .loader {
    position: absolute;
    top: calc(50% - 40px);
    left: calc(50% - 40px);
    width: 80px;
    height: 80px;
    clip: rect(0, 80px, 80px, 40px);
    animation: loader-animate 1.5s linear infinite;

    &::after {
      position: absolute;
      width: 80px;
      height: 80px;
      clip: rect(0, 80px, 80px, 40px);
      content: '';
      border-radius: 50%;
      animation: loader-animate-after 1.5s ease-in-out infinite;
    }
  }

  @keyframes loader-animate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(220deg);
    }
  }

  @keyframes loader-animate-after {
    0% {
      box-shadow: inset #fff 0 0 0 17px;
      transform: rotate(-140deg);
    }

    50% {
      box-shadow: inset #fff 0 0 0 2px;
    }

    100% {
      box-shadow: inset #fff 0 0 0 17px;
      transform: rotate(140deg);
    }
  }
}

.existing--text {
  color: red !important;
}

.saved--text {
  color: green !important;
}

.v-tooltip__content--fixed {
  margin-top: 20px;
}

.logoContainer {
  width: 108px;
  max-width: 108px;
  height: 100%;
  padding-top: 22px;
}

.searchBar {
  border: 0 !important;
  border-radius: 16px !important;
}

.searchBarContainer {
  width: 100%;
  max-width: 900px;
  height: 100%;
}

.searchBarExpanded {
  width: 100%;
  max-width: 700px;
}

.appBarAvatar {
  cursor: pointer;
}

.v-input--is-disabled {
  opacity: 0.5;
}

.tabContent {
  margin-top: 20px;
  border-bottom: 1px solid #ccc;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%),
    0 1px 5px 0 rgb(0 0 0 / 12%);
}

.tabStyling {
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
}

.elevation-2 {
  margin-top: 40px;
}

.disableSearchdButton {
  opacity: 0.5;
}

.disableSearchdButton:hover {
  cursor: default;
  opacity: 0.5;
}

.btn-reasons {
  color: #0476d9 !important;
  text-transform: capitalize;
}

.btn-divider {
  margin: 0 10px;
  background: #000;
}

.card-action-center {
  justify-content: center;
}
.full-width {
  width: 99%;
  margin: 0 auto;
}
.pageTitle {
  margin: 0;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: -0.3px;
}
///////////////////////////////////////////////////////////////////////
@import '@design';
</style>
